module.exports = __webpack_public_path__ + "static/img/player_04_ph.64022f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_04_ph.png
// module id = +otz
// module chunks = 0